import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Honeybadger from '@honeybadger-io/js';
import { lazy, Suspense, useEffect } from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { PATH, makePath, useButtonClickTracker, useRouteTracker, useNavigationTracker, getCookie, } from 'shared';
import { Routes as CreditApplicationRoutes } from './credit_application';
import Layout from './Layout';
const ApplicantsRoutes = lazy(() => import('./applicants').then((m) => ({ default: m.Routes })));
const EDSRoutes = lazy(() => import('./apply/eds').then((m) => ({ default: m.Routes })));
const StoreLookup = lazy(() => import('./credit_application/views/StoreLookup'));
const FindMyAccountRoutes = lazy(() => import('./find-my-account/Routes'));
const FlexFinalizeRoutes = lazy(() => import('./flex-finalize').then((m) => ({ default: m.Routes })));
const ProveRoutes = lazy(() => import('./prove').then((m) => ({ default: m.Routes })));
const ReceiptRoutes = lazy(() => import('./receipt').then((m) => ({ default: m.Routes })));
const DownPage = lazy(() => import('./views/DownPage'));
const ProviderCallbackSuccess = lazy(() => import('./views/ProviderCallbackSuccess'));
function Routes() {
    const { path } = useRouteMatch();
    useButtonClickTracker();
    useRouteTracker();
    useNavigationTracker();
    const consumerAppDown = process.env
        .REACT_APP_CONSUMER_DOWN_MESSAGE_ENABLED;
    async function setHoneybadgerContext() {
        let ip = '';
        try {
            const response = await fetch('https://api.ipify.org?format=json', {
                signal: AbortSignal.timeout(5000),
            });
            const data = await response.json();
            ip = data.ip;
        }
        catch {
            ip = 'unknown';
        }
        Honeybadger.setContext({
            ipAddress: ip,
            hyperDxSessionId: getCookie('__rum_sid'),
        });
    }
    useEffect(() => {
        setHoneybadgerContext();
    }, []);
    return (_jsx(Layout, { children: _jsxs(Suspense, { fallback: null, children: [consumerAppDown === true && _jsx(DownPage, {}), consumerAppDown !== true && (_jsxs(Switch, { children: [_jsx(Route, { exact: true, path: makePath(path, '/:credit_application_id/aff/provider_success'), children: _jsx(ProviderCallbackSuccess, { lender: "aff" }) }), _jsx(Route, { path: makePath(path, '/receipt/:receiptIdEncoded'), children: _jsx(ReceiptRoutes, {}) }), _jsx(Route, { path: makePath(path, PATH.FIND_MY_ACCOUNT), children: _jsx(FindMyAccountRoutes, {}) }), _jsx(Route, { path: `${PATH.CREDIT_PORTAL}${PATH.CREDIT_APPLICATION}${PATH.EDS.BASE}`, exact: false, children: _jsx(EDSRoutes, {}) }), _jsx(Route, { path: `${PATH.CREDIT_PORTAL}${PATH.FLEX_FINALIZE}`, exact: false, children: _jsx(FlexFinalizeRoutes, {}) }), _jsx(Route, { path: makePath(path, PATH.CREDIT_APPLICATION), children: _jsx(CreditApplicationRoutes, {}) }), _jsx(Route, { path: makePath(path, PATH.APPLICANTS), children: _jsx(ApplicantsRoutes, {}) }), _jsx(Route, { path: makePath(path, '/store/:id'), exact: true, children: _jsx(StoreLookup, {}) }), _jsx(Route, { path: makePath(path, '/location/:id'), exact: true, children: _jsx(StoreLookup, {}) }), _jsx(Route, { path: makePath(path, PATH.PROVE?.BASE), exact: false, children: _jsx(ProveRoutes, {}) }), _jsx(Redirect, { path: "*", to: makePath(path, PATH.CREDIT_APPLICATION) })] }))] }) }));
}
export default Routes;
